import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Report extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get financialResultIncome() {
    try {
      return JSON.parse(
        get(this, '_wyniki_finansowe_w_latach_przychod.value', '')
      );
    } catch (e) {
      console.log('Error');
      return null;
    }
  }
  get financialResultProfitLoss() {
    try {
      return JSON.parse(
        get(this, '_wyniki_finansowe_w_latach_zysk_strata.value', '')
      );
    } catch (e) {
      console.log('Error');
      return null;
    }
  }

  get _dataSetUrl() {
    return get(this, '_zestaw_danych.value[0].url', '');
  }

  get period() {
    return get(this, '_kwartal.value[0].codename', '');
  }

  get year() {
    return get(this, '_rok.value', '');
  }

  get reportImage() {
    return get(this, '_miniaturka.value[0].url', '');
  }

  get prevYear() {
    return this.year - 1;
  }

  get nextYear() {
    return this.year + 1;
  }

  get pdfUrl() {
    return get(this, '_raport_pdf.value[0].url', '');
  }

  get videoComment() {
    return get(this, '_komentarz_video[0]', {});
  }

  get videoPoster() {
    return get(this, '_komentarz_video[0].plakat_filmu.value[0].url', '');
  }

  get videoLink() {
    return get(this, '_komentarz_video[0].link_do_filmu.value', '');
  }

  get financialResultFile() {
    return get(this, '_wyniki_finansowe_zalacznik.value[0].url', '');
  }

  get historyOfCapitalGroupEvents() {
    return get(this, '_historia_grupy_kapitalowej', []);
  }

  get relevantEvents() {
    return get(this, '_wydarzenia', []);
  }

  get incomeTabOneComment() {
    return get(this, '_przychody_wg_dzialalnosci___komentarz[0]');
  }

  get incomeTabOneChartData() {
    return get(this, '_przychody_wg_dzialalnosci___wykres');
  }

  get incomeTabTwoComment() {
    return get(this, '_przychody_wg_sektorow___komentarz[0]');
  }

  get incomeTabTwoChartData() {
    return get(this, '_przychody_wg_sektorow___wykres');
  }

  get incomeTabThreeComment() {
    return get(this, '_przychody_wg_spolek___komentarz[0]');
  }

  get incomeTabThreeChartData() {
    return get(this, '_przychody_wg_spolek___wykres');
  }

  get incomeTabFourComment() {
    return get(this, '_przychody_wg_kraju_pochodzenia___komentarz[0]');
  }

  get incomeTabFourChartData() {
    return get(this, '_przychody_wg_kraju_pochodzenia___wykres');
  }

  get forecastsAndPlansText() {
    return get(this, '_prognozy_i_plany.value', '');
  }

  get forecastsAndPlansChartData() {
    return get(this, '_prognozy_wykres');
  }

  get mainIncomeSoruces() {
    return get(this, '_zrodla_przychodu', []);
  }

  get shareholdersStructureChartData() {
    return get(this, '_struktura_akcjonariatu___wykres');
  }

  get capitalStructureText() {
    return get(this, '_struktura_kapitalu.value', '');
  }

  get consolidatedFinancialReportLink() {
    return get(this, '_sprawozdanie_finansowe_zalacznik.value[0].url', '');
  }

  get basicRisksAndThreatsDescription() {
    return get(this, '_zagrozenia', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/Report.js